module.exports = __webpack_public_path__ + "static/media/axe.2c335ad7.png";